import React from 'react';
import './Popular.css';
import Item from '../Item/Item';
import all_product from '../popular_products';

const Popular = () => {
    return (
        <div className="popular">
            <h1>Confira nossos Produtos</h1>
            <hr />
            <div className="popular-item">
                {all_product.length === 0 ? (
                    <p>Nenhum produto encontrado</p>
                ) : (
                    all_product.map((item) => (
                        <Item
                            key={item.id}
                            id={item.id}
                            name={item.name}
                            // Usa a primeira imagem do array
                            image={item.images[0]}
                            new_price={item.new_price}
                            old_price={item.old_price}
                        />
                    ))
                )}
            </div>
        </div>
    );
};

export default Popular;
